import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import type { TodayLink } from './model';

/**
 * A typed link for one purchasing-today row (TASK-0250): each target keeps its
 * own route's search shape, so a renamed filter fails the type check here.
 */
export function TodayLinkTo({
  link,
  className,
  children,
  'aria-label': ariaLabel,
}: {
  link: TodayLink;
  className?: string;
  children: ReactNode;
  'aria-label'?: string;
}) {
  switch (link.to) {
    case '/purchasing/guide':
      return (
        <Link to="/purchasing/guide" className={className} aria-label={ariaLabel}>
          {children}
        </Link>
      );
    case '/purchasing/import':
      return (
        <Link
          to="/purchasing/import"
          search={link.search}
          className={className}
          aria-label={ariaLabel}
        >
          {children}
        </Link>
      );
    case '/organize':
      return (
        <Link
          to="/organize"
          search={link.search}
          className={className}
          aria-label={ariaLabel}
        >
          {children}
        </Link>
      );
  }
}
